export const GITHUB_PROJECT_REPO =
  "https://github.com/sanyamdogra/rick-morty-web";
